import uuidv4 from '@/helpers/uuid';

const EvaluateItemsConfig = {
  'logic-condition': {
    type: 'logic-condition',
    payload: {
      expressions: [],
      else: [],
    },
  },
  'logic-statement': {
    type: 'logic-statement',
    payload: {
      variable: null,
      assignment_type: 'value',
      dataType: null,
      value: '',
    },
  },
  'logic-parallel': {
    type: 'logic-parallel',
    payload: [],
  },
  'logic-transition': {
    type: 'logic-transition',
    payload: {
      id: uuidv4(),
      type: 'end',
      value: null,
      data_binding: [],
    },
  },
  'action-execute-api': {
    type: 'action-execute-api',
    payload: {
      method: 'POST',
      url: '',
      headers: {},
      parameters: {},
      body_type: 'form_data',
      body: [],
      file: '',
      response: {},
      on_error: '',
    },
  },
  'action-invoke-flow': {
    type: 'action-invoke-flow',
    payload: {
      flow_id: '',
      data_binding: [],
    },
  },
  'action-schedule': {
    type: 'action-schedule',
    payload: {
      flow_id: '',
      schedule_type: 'value',
      recurring: false,
      variable: '',
      data_binding: [],
      frequency: 'minute',
      schedule: 1,
      hour: 0,
      minute: 0,
    },
  },
  'action-send-email': {
    type: 'action-send-email',
    payload: {
      email_template: '',
      from: {},
      fromEmail: '',
      to: [],
      data_binding: [],
      attachments: [],
    },
  },
  'document-image': {
    type: 'document-image',
    payload: {
      variable: null,
      template: '',
      data: [],
      file_name: 'image.png',
      width: 1280,
      height: 800,
      auto_inject: false,
      provider: '',
      model: '',
      content: [],
    },
  },
  'document-html': {
    type: 'document-html',
    payload: {
      variable: null,
      template: '',
      data: [],
      file_name: 'document.html',
      auto_inject: false,
      provider: '',
      model: '',
      content: [],
    },
  },
  'document-pdf': {
    type: 'document-pdf',
    payload: {
      variable: null,
      template: '',
      data: [],
      file_name: 'document.pdf',
      auto_inject: false,
      provider: '',
      model: '',
      content: '',
    },
  },
  'response-json': {
    type: 'response-json',
    payload: [],
  },
  'response-xml': {
    type: 'response-xml',
    payload: {
      variable: '',
    },
  },
  'response-excel': {
    type: 'response-excel',
    payload: {
      file: '',
    },
  },
  'response-pdf': {
    type: 'response-pdf',
    payload: {
      file: '',
    },
  },
  'response-text': {
    type: 'response-text',
    payload: [],
  },
  'response-card': {
    type: 'response-card',
    payload: {
      title: '',
      text: '',
      chart: [],
      table: '',
      insights: [],
    },
  },
  'response-image': {
    type: 'response-image',
    payload: {
      file: [],
    },
  },
  'response-html': {
    type: 'response-html',
    payload: {
      file: '',
    },
  },
  'ai-agent': {
    type: 'ai-agent',
    payload: {
      // model
      provider: '',
      model: '',
      // The selected model's full config object (capabilities, token param, etc.),
      // published with the project so the runtime can shape requests per-model.
      model_config: null,
      temperature: '0.3',
      max_tokens: '4096',

      // behaviour
      persona: '',
      instructions: '',

      // tools — full block instances dropped onto the agent, each with an
      // editable description override + per-tool policy (auto | confirm | off).
      tools: [],

      // read-only project variables: prompt-injected, optionally exposed as a get_input tool
      inputs: [], // [{ ref, expose_as_tool }]

      // session memory (Phase 4 consumes adapter + compaction)
      session: {
        adapter: '',
        compaction: { strategy: 'token', threshold: 0.7, keep_recent_turns: 6, summary_max_tokens: 1024 },
      },

      // dynamic response
      response: { mode: 'stream' },

      // human-in-the-loop / approvals — inline approval is always available;
      // approvers (emails) opt into email approval using approval_template.
      // Approval channels are independent: `chat` = the user approves inline in
      // chat; `email` = external approvers approve via emailed links (needs a
      // `from` sender, approvers, and a template).
      hitl: { chat: true, email: false, from: {}, fromEmail: '', approvers: [], approval_template: '', timeout_ms: 86400000, on_timeout: 'reject' },

      // programmatic output target
      output_variable: '',

      // guards
      limits: { max_iterations: 12, max_tool_calls: 30, timeout_ms: 120000 },
    },
  },
  'ai-text-gen': {
    type: 'ai-text-gen',
    payload: {
      provider: '',
      model: '',
      model_config: null,
      features: [],
      persona: '',
      context: '',
      replace_citations: 'yes',
      reasoning_effort: 'medium',
      search_effort: 'medium',
      max_tokens: '1000',
      file: '',
      temperature: '0.2',
      output_type: 'simple',
      cache: 'no',
      response: {},
      structuredOutput: [],
    },
  },
  'ai-deepresearch': {
    type: 'ai-deepresearch',
    payload: {
      response_variable: '',
      reasoning_variable: '',
      citations_variable: '',
      provider: '',
      model: '',
      persona: '',
      context: '',
      replace_citations: 'yes',
      search_effort: 'medium',
      max_length: '5000',
    },
  },
  'ai-text-generation': {
    type: 'ai-text-generation',
    payload: {
      response_variable: '',
      provider: '',
      model: '',
      persona: '',
      context: '',
      file: '',
      max_length: '100',
      temperature: '0.2',
    },
  },
  'crypto-aes-encrypt': {
    type: 'crypto-aes-encrypt',
    payload: {
      variable: '',
      key: '',
      payload: '',
    },
  },
  'crypto-aes-decrypt': {
    type: 'crypto-aes-decrypt',
    payload: {
      variable: '',
      key: '',
      payload: '',
    },
  },
  'crypto-jwt-sign': {
    type: 'crypto-jwt-sign',
    payload: {
      variable: '',
      algorithm: 'HS256',
      secret: '',
      payload: '',
    },
  },
  'crypto-jwt-verify': {
    type: 'crypto-jwt-verify',
    payload: {
      variable: '',
      token: '',
      algorithm: 'HS256',
      secret: '',
    },
  },
  'crypto-jwt-decode': {
    type: 'crypto-jwt-decode',
    payload: {
      token: '',
    },
  },
  'crypto-jwt-isexpired': {
    type: 'crypto-jwt-isexpired',
    payload: {
      token: '',
    },
  },
  'data-chart': {
    type: 'data-chart',
    payload: {
      variable: null,
      data: null,
      charts: [],
    },
  },
  'data-analysis': {
    type: 'data-analysis',
    payload: {
      variable: null,
      value: {
        arguments: [],
        function: null,
      },
    },
  },
  'data-adapter': {
    type: 'data-adapter',
    payload: {
      variable: '',
      adapter_type: '',
      tool_name: '',
      tools: [],
      arguments: {},
    },
  },
  'data-transform': {
    type: 'data-transform',
    payload: {
      title: '',
      inputVariable: '',
      outputVariable: '',
      steps: [],
    },
  },
  'data-mapper-datatable-to-excel': {
    type: 'data-mapper-datatable-to-excel',
    payload: {},
  },
  'data-mapper-excel-to-datatable': {
    type: 'data-mapper-excel-to-datatable',
    payload: {
      inputVariable: '',
      outputVariable: '',
      sheet: { refType: 'index', index: 1 },
      headers: { mode: 'row', rowIndex: 1 },
      dataRows: { mode: 'afterHeader', startRow: 2 },
      columns: { mode: 'all' },
      options: { skipEmptyRows: true, emptyCellValue: 'null' },
      aliases: { enabled: false, mappings: [] },
    },
  },
  // Service-agnostic. Choosing a service adds that service's own settings under its
  // own key (e.g. parquet_config, see data-export/services.js), so services never mix.
  'data-export': {
    type: 'data-export',
    payload: {
      variable: '',
      adapter_type: '',
      tool_name: '',
      arguments: {},
      destination_adapter: '',
      service: '',
      mode: 'incremental',
      start_date: '',
    },
  },
};

export default EvaluateItemsConfig;

// Create a fresh evaluate-item instance from a block type's config template.
// IMPORTANT: regenerate ids so every instance is unique. The config templates are
// defined once at module load, so any baked id (e.g. logic-transition's
// payload.id) would otherwise be shared by every block created from it.
export function createEvaluateItem(type) {
  const item = JSON.parse(JSON.stringify(EvaluateItemsConfig[type]));
  item.id = uuidv4();
  if (item.payload && Object.prototype.hasOwnProperty.call(item.payload, 'id')) {
    item.payload.id = uuidv4();
  }
  return item;
}
